export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2PQfPHnPwAGWAMNdhLx4AAAAABJRU5ErkJggg=="